import { DEFAULT_PAGE_SIZE } from 'app/constants/api';

export const DEFAULT_PAGINATION_SETTINGS = {
  limit: DEFAULT_PAGE_SIZE,
  offset: 0,
  total: 0,
  reload: true,
};
